export default __webpack_public_path__ + "static/media/img-paper-wallet-2.c03b53f8.png";